const emptyString = '';

export const isEmpty = (input: string): boolean => {
    return input.trim() === emptyString;
};

export const emptyStringFallback = (input: string | undefined, fallback: string | undefined): string => {
    const parseFallback = fallback && !isEmpty(fallback) ? fallback : emptyString;
    return input && !isEmpty(input) ? input : parseFallback;
};